import { format } from 'date-fns';

const ISO_DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const ISO_DATE_TIME_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
const DD_MM_YYYY_PATTERN = /^(\d{2})-(\d{2})-(\d{4})$/;

function replaceDateString(value: string): unknown {
  const dateOnlyMatch = value.match(ISO_DATE_ONLY_PATTERN);
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    return `${day}-${month}-${year}`;
  }

  if (ISO_DATE_TIME_PATTERN.test(value)) {
    return format(new Date(value), 'dd-MM-yyyy');
  }

  return value;
}

function reviveDateString(value: string): unknown {
  const match = value.match(DD_MM_YYYY_PATTERN);
  if (!match) {
    return value;
  }

  const [, day, month, year] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return isNaN(date.getTime()) ? value : date;
}

export function initialAssessmentReplacer(_key: string, value: unknown): unknown {
  return typeof value === 'string' ? replaceDateString(value) : value;
}

export function initialAssessmentReviver(_key: string, value: unknown): unknown {
  return typeof value === 'string' ? reviveDateString(value) : value;
}

export function serializeInitialAssessmentForm(form: unknown): string {
  return JSON.stringify(form, initialAssessmentReplacer);
}

export function parseInitialAssessmentForm(formDetails: string): unknown {
  return JSON.parse(formDetails, initialAssessmentReviver);
}
